"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function locationConstraintMiddleware(regionProvider) {
    var _this = this;
    return function (next) { return function (args) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var region, CreateBucketConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, regionProvider()];
                case 1:
                    region = _a.sent();
                    CreateBucketConfiguration = args.input.CreateBucketConfiguration;
                    if (!CreateBucketConfiguration ||
                        !CreateBucketConfiguration.LocationConstraint) {
                        args = tslib_1.__assign({}, args, { input: tslib_1.__assign({}, args.input, { CreateBucketConfiguration: { LocationConstraint: region } }) });
                    }
                    else if (region === "us-east-1") {
                        args = tslib_1.__assign({}, args, { input: tslib_1.__assign({}, args.input, { CreateBucketConfiguration: undefined }) });
                    }
                    return [2 /*return*/, next(args)];
            }
        });
    }); }; };
}
exports.locationConstraintMiddleware = locationConstraintMiddleware;
//# sourceMappingURL=index.js.map